module.exports = __webpack_public_path__ + "img/1-WKN.245cedb.jpg";